<template>
  <div class="editor col-md-12">
    <div
      class="menubar is-hidden"
      :class="{ 'is-focused': editor.isFocused }"
    >
      <v-tooltip top v-if="!toolbarOptions.length || toolbarOptions.includes('bold')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            tile
            small
            @click.prevent="editor.chain().focus().toggleBold().run()"
            color="grey darken-3"
            :class="{ 'is-active': editor.isActive('bold') }"
          >
            <v-icon :color=" editor.isActive('bold') ? 'primary' : 'grey darken-3'" x-small>far fa-bold</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltip.bold')}}</span>
      </v-tooltip>

      <v-tooltip top v-if="!toolbarOptions.length || toolbarOptions.includes('italic')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            tile
            small
            @click.prevent="editor.chain().focus().toggleItalic().run()"
            color="grey darken-3"
            :class="{ 'is-active': editor.isActive('italic') }"
          >
            <v-icon :color=" editor.isActive('italic') ? 'primary' : 'grey darken-3'" x-small>far fa-italic</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltip.italic')}}</span>
      </v-tooltip>

      <v-tooltip top v-if="!toolbarOptions.length || toolbarOptions.includes('h1')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            tile
            small
            @click.prevent="editor.chain().focus().toggleHeading({ level: 1 }).run()"
            color="grey darken-3"
            :class="{ 'is-active': editor.isActive('heading', {level: 1}) }"
          >
            <v-icon :color=" editor.isActive('heading', {level: 1}) ? 'primary' : 'grey darken-3'" x-small>far fa-h1</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltip.headingOne')}}</span>
      </v-tooltip>

      <v-tooltip top v-if="!toolbarOptions.length || toolbarOptions.includes('h2')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            tile
            small
            @click.prevent="editor.chain().focus().toggleHeading({ level: 2 }).run()"
            color="grey darken-3"
            :class="{ 'is-active': editor.isActive('heading', {level: 2}) }"
          >
            <v-icon :color=" editor.isActive('heading', {level: 2}) ? 'primary' : 'grey darken-3'" x-small>far fa-h2</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltip.headingTwo')}}</span>
      </v-tooltip>

      <v-tooltip top v-if="!toolbarOptions.length || toolbarOptions.includes('bulletList')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            tile
            small
            @click.prevent="editor.chain().focus().toggleBulletList().run()"
            color="grey darken-3"
            :class="{ 'is-active': editor.isActive('bulletList') }"
          >
            <v-icon :color=" editor.isActive('bulletList') ? 'primary' : 'grey darken-3'" x-small>far fa-list-ul</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltip.bulletList')}}</span>
      </v-tooltip>
    </div>
    <editor-content class="editor__content" :editor="editor"/>
  </div>
</template>

<script>
import i18n from "@/services/i18n";
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'

import {marked} from "marked";


export default {
  name: 'neoparent-tiptap',
  props: ['content', "type"],
  components: {
    EditorContent,
  },
  i18n: i18n,
  data() {
    return {
      modalShow: false,
      isPublished: false,
      toolbarOptions: [],
      editor: new Editor({
        extensions: [
          StarterKit.configure({
            heading: {
              levels: [1, 2, 3]
            },
            paragraph: {
              HTMLAttributes: {
                class: 'clearfix'
              }
            }
          }),
        ],
        onUpdate: () => {
          const html = this.editor.getHTML();
          this.$root.$emit('mediligo-markdown-editor-save', {content:  html, type: this.type});
        },
        content: marked(this.content ? this.content : "")
      }),
    }
  },

  mounted: function () {
  },

  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>

<style lang="css" scoped>
::v-deep .ProseMirror > * + * {
  margin-top: 0.75em;
}

::v-deep .ProseMirror ol {
  padding: 0 1rem;
  list-style: decimal !important;
}

::v-deep .ProseMirror ul {
  padding: 0 1rem;
  list-style: disc !important;
}

::v-deep li {
  display: list-item !important;
  list-style: disc !important;

}

</style>
